import React, {FC} from "react";
import {MDXRemoteSerializeResult, MDXRemote} from "next-mdx-remote";
import {Title} from "./title";
import {Intro} from "./intro";
import {OfferLink} from "./offer-link";
import {Youtube} from "./youtube";
import {HiddenMarkup} from "./hidden-markup";
import {Temp} from "./temp";
import {Meters} from "./meters";
import {Card} from "./card";
import {Forex} from "./forex";
import {PriceTable} from "./price-table";
import {TripDetailHeading} from "./headings/trip-detail-heading";
import {A} from "./a";

interface VisaRequirementsProps {

    children?: string
    source?: MDXRemoteSerializeResult
}

const initialComponents = {
    Title,
    Intro,
    OfferLink,
    Youtube,
    Overview: HiddenMarkup,
    Temp,
    Meters,
    Card,
    Forex,
    PriceTable,
    h2: TripDetailHeading,
    a: A
}


/*
   this gets used in three ways:
   1) The special regex which looks for <VisaRequirements> boundaries when importing country pages and hacks out a separate file
   2) the markdown of the country page will use this with children in which case we just spit it out
   3) it's used by the trip detail pages with no children and

 */

export function VisaRequirements({source, children}: VisaRequirementsProps) {
    return <>
        {source && <MDXRemote {...source} components={initialComponents}/>}
        {children}
    </>
}
